export * from './xyhszj.component';